import Vue from 'vue'

const state = {
    selected_user: ''
}

const actions = {
    SET_SELECTED_USER(context, [selected_user]) {
        context.commit('SAVE_SELECTED_USER', [selected_user])
    },
}

const mutations = {
    SAVE_SELECTED_USER: (state, [selected_user]) => {
        Vue.set(state, 'selected_user', selected_user)
    },
}

const getters = {
    selected_user: state => {
        return state.selected_user
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}